export default __webpack_public_path__ + "7f3b682080b43dafe864ce4832f3ed75.svg";